import Croatia from './croatia.png';
import UnitedKingdom from './united-kingdom.png';

const images = {
    croatian: Croatia,
    english: UnitedKingdom
}

export default images;